<template>
  <layout-header></layout-header>
  <layout-sidebar></layout-sidebar>

  <!-- Page Wrapper -->
  <div class="page-wrapper">
    <!-- Page Content -->
    <div class="content container-fluid">
      <!-- Page Header -->
      <breadcrumb-header :title="title" :path="path" :text="text" />
      <!-- /Page Header -->

      <!-- Search Filter -->
      <!-- <search-filter @searchClicked="searchClicked"></search-filter> -->
      <!-- /Search Filter -->

      <div class="row">
        <div class="col-md-12">
          <div class="showentries mb-3 custom-select">
            <div class="d-flex align-items-center gap-2"><span>Show</span>
              <select v-model="perPage" @change="current = 1; getUsers()" style="outline: none">
                <option value="10">10</option>
                <option value="25">25</option>
                <option value="50">50</option>
                <option value="100">100</option>
              </select>
              <span>entries</span>
            </div>
          </div>
          <div v-if="!loader">
            <div class="table-responsive">

              <a-table class="stripped table-hover" :columns="columns" :data-source="usersData" :pagination="false"
                v-if="usersData.length">
                <template #bodyCell="{ column, record }">
                  <!-- <template v-if="column.key === 'name'">
                  <h2 class="table-avatar">
                    <router-link :to="{ name: 'EmployeeProfile', params: {id: record.id} }" class="avatar">
                      <img :src="getImage(record.profile_image_path)" alt="User Image"
                        v-if="record.profile_image_path" />
                      <img src="../../../assets/img/avatar/avatar-29.png" alt="User Image" v-else />
                    </router-link>
                    <router-link :to="{ name: 'EmployeeProfile', params: {id: record.id} }">{{ record.name }}</router-link>
                  </h2>
                </template> -->
                  <template v-if="column.key === 'name'">
                    <h2 class="table-avatar">
                      <a href="javascript:;" class="avatar" @click="openImagePreview(record)">
                        <img :src="getImage(record.profile_image_path)" alt="User Image"
                          v-if="record.profile_image_path" />
                        <img src="../../../assets/img/avatar/avatar-29.png" alt="User Image" v-else />
                      </a>
                      <div class="text-end dropdown-container">
                        <action-dropdown @banked-time="bankedTimeClicked" :employee="record" variant="text" :reportAsEvent="true" @edit="editClicked" @leaves="leavesClicked"
                          @attendance="attendanceClicked" @sick-leave="sickLeaveClicked" @toggle-monitoring="monitorClicked"
                          @add-face-template="addFaceTemplateClicked" @face-templates="faceTemplatesClicked" @report="viewReport"
                          @reset-password="resetPasswordClicked" @assign-employee="assignEmployeeClicked"/>
                      </div>
                    </h2>
                  </template>
                  <template v-else-if="column.key === 'locations'">
                    <span v-for="(item, index) in record.locations" :key="index" class="inline-item">
                      <span v-if="index > 0">,</span>{{ item.name }}
                    </span>
                  </template>
                  <template v-else-if="column.key === 'joining_date'">
                    {{ formatDate(record.joining_date) }}
                  </template>
                  <template v-else-if="column.key === 'Role'">
                    {{ companyIdToCompanyRole(record.company_role_id) }}
                  </template>
                  <template v-else-if="column.key === 'is_monitored'">
                    <span class="badge" :class="record.is_monitored ? 'bg-success' : 'bg-secondary'">
                      {{ record.is_monitored ? 'Monitored' : 'Not Monitored' }}
                    </span>
                  </template>
                  <!-- <template v-else-if="column.key === 'action'">
                  <div class="text-end">
                    <div class="dropdown dropdown-action">
                      <a href="javascript:;" class="action-icon dropdown-toggle" data-bs-toggle="dropdown"
                        aria-expanded="false"><i class="material-icons">more_vert</i></a>
                      <div class="dropdown-menu dropdown-menu-right">
                        <a class="dropdown-item" href="javascript:;" @click="toggleMonitoring(record)">
                          <i class="fa fa-street-view m-r-5"></i>
                          {{ record.is_monitored ? 'Stop Monitoring' : 'Start Monitoring' }}
                        </a>
                        <router-link class="dropdown-item" :to="{ name: 'EmployeeProfile', params: { id: record.id } }">
                          <i class="fa fa-eye m-r-5"></i>View Profile
                        </router-link>
                        <router-link class="dropdown-item" :to="{ name: 'employeeReport', params: { id: record.id } }">
                          <i class="fa fa-th m-r-5"></i>Employee Report
                        </router-link>
                      </div>
                    </div>
                  </div>
                </template> -->
                </template>
              </a-table>
              <div v-else>
                <div class="card text-center">
                  <div class="card-body">
                    <img src="../../../assets/img/avatar/no-data.png" alt="no-data" srcset="" class="responsive-img">
                    <p>No monitored employees found.</p>
                  </div>
                </div>
              </div>
              <div class="d-flex justify-content-center">
                <a-pagination v-model:current="current" v-model:pageSize="perPage" :total="total" @change="getUsers"
                  show-less-items class="mt-3 " :showSizeChanger="false">
                  <template #itemRender="{ type, originalElement }">
                    <a v-if="type === 'prev'">Previous</a>
                    <a v-else-if="type === 'next'">Next</a>
                    <component :is="originalElement" v-else></component>
                  </template>
                </a-pagination>
              </div>
            </div>

          </div>
          <div class="d-flex justify-content-center text-center mt-5" v-else>
            <div class="spinner-border" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- /Page Content -->
    <employee-modal @userAdded="getUsers"></employee-modal>
    <edit-employee-modal ref="editEmployee" @editedUser="getUsers"></edit-employee-modal>
    <add-face-template-modal ref="addface"></add-face-template-modal>
    <face-templates-modal ref="faceTemplates"></face-templates-modal>
    <sick-leave-modal ref="sickLeave"></sick-leave-modal>
    <leaves-admin-modal ref="leaveAdmin" @allLeaves="getUsers"></leaves-admin-modal>
    <sick-leave-details-modal ref="sickLeaveDetails"></sick-leave-details-modal>
    <employee-report-modal ref="employeeReportModal"></employee-report-modal>
    <reset-password-modal ref="resetPasswordModal"></reset-password-modal>
    <assign-employee-modal ref="assignEmployeeModal" @updated="getUsers"></assign-employee-modal>

    <!-- Image Preview Modal -->
    <div class="modal fade" id="image_preview_modal" tabindex="-1" aria-labelledby="imagePreviewLabel"
      aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="imagePreviewLabel">{{ selectedEmployeeName }}</h5>
            <button type="button" class="btn-close close-btn" data-bs-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body text-center">
            <img :src="selectedImageUrl" alt="Employee Image" class="img-fluid preview-image" />
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Page Wrapper -->
    <view-banked-time-details-modal ref="viewBankedTimeDetails"></view-banked-time-details-modal>
</template>

<script>
import axios from 'axios';
import { Modal } from 'bootstrap';
import { getImage, formatUSDate, formatDateTimeStandardShort } from "@/utils/util-funcitons";
import { dateRangeStart, dateRangeEnd } from "@/utils/util-var";
import { VUE_APP_API_BASE_URL } from "../../../config";
import ActionDropdown from "@/components/action-dropdown.vue";
import { monitorMixin } from "@/mixins/monitorMixin";
import FaceTemplatesModal from "@/components/modal/face-templates-modal.vue";
import AssignEmployeeModal from "@/components/modal/assign-employee-modal.vue";

const columns = [
  {
    title: "Name",
    dataIndex: "name",
    key: "name",
    sorter: {
      compare: (a, b) => {
        a = a.name.toLowerCase();
        b = b.name.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Employee ID",
    dataIndex: "employee_code",
    key: "employee_code",
    sorter: {
      compare: (a, b) => {
        const numA = Number(a.employee_code);
        const numB = Number(b.employee_code);
        return numA > numB ? -1 : numA < numB ? 1 : 0;
      },
    },
  },
  {
    title: "Location",
    dataIndex: "locations",
    key: "locations",
  },
  {
    title: "Email",
    dataIndex: "email",
    key: "email",
  },
  {
    title: "Join Date",
    dataIndex: "joining_date",
    key: "joining_date",
    sorter: {
      compare: (a, b) => {
        const dateA = new Date(a.joining_date);
        const dateB = new Date(b.joining_date);
        return dateA > dateB ? -1 : dateA < dateB ? 1 : 0;
      },
    },
  },
  {
    title: "Role",
    dataIndex: "Role",
    key: "Role",
  },
  {
    title: "Status",
    dataIndex: "is_monitored",
    key: "is_monitored",
  },
  //   {
  //     title: "Action",
  //     key: "action",
  //   },
];

export default {
  data() {
    return {
      columns,
      title: "Monitored Employees",
      path: "Dashboard",
      text: "Monitored Employees",
      text1: "",
      usersData: [],
      perPage: 10,
      current: 1,
      total: 0,
      employee_code: "",
      employee_name: "",
      company_role_id: "",
      companyId: [],
      loader: false,
      selectedImageUrl: "",
      selectedEmployeeName: "",
      startDate: formatUSDate(dateRangeStart),
      endDate: formatUSDate(dateRangeEnd),
    };
  },
  components: {
    ActionDropdown,
    FaceTemplatesModal,
    AssignEmployeeModal
  },
  mixins: [monitorMixin],
  mounted() {
    this.getUsers();
    this.getCompanyRoles();
  },

  methods: {
    bankedTimeClicked(record) {
      if(this.$refs.viewBankedTimeDetails) {
        this.$refs.viewBankedTimeDetails.updateValues(record, {});
      }
    },

    searchClicked(data) {
      this.employee_code = data.employee_code;
      this.employee_name = data.employee_name;
      this.company_role_id = data.company_role_id;
      this.current = 1;
      this.getUsers();
    },
    getImage,
    getUsers() {
      this.loader = true;
      if (Number(this.perPage) >= this.total) {
        this.current = 1
      }
      const params = {
        per_page: this.perPage,
        // employee_code: this.employee_code,
        // employee_name: this.employee_name,
        // company_role_id: this.company_role_id,
        // is_monitored: 1
      }
      axios.post(`${VUE_APP_API_BASE_URL}/user/monitored-users?page=${this.current}`, { params: params })
        .then((response) => {

          if (response.data.status) {
            this.usersData = response.data.data.data;
            this.current = response.data.data.current_page;

            this.total = response.data.data.total;

            this.usersData.forEach(element => {
              element["name"] = element["first_name"] + " " + element["last_name"];
            });
          } else {
            this.errorMessage = response.data.message ?? "";
          }
        })
        .finally(() => {
          this.loader = false;
        });
    },

    // formatDate(dateString) {
    //   const date = new Date(dateString);
    //   return new Intl.DateTimeFormat('en-GB', { dateStyle: 'long' }).format(date);
    // },
    formatDate(dateString) {
      const date = new Date(dateString);
      // Then specify how you want your dates to be formatted
      return formatDateTimeStandardShort(date);
    },

    companyIdToCompanyRole(id) {
      const company = this.companyId.find(item => item.id === id);
      return company ? company.name : null;
    },

    async getCompanyRoles() {
      await axios.get(`${VUE_APP_API_BASE_URL}/company-role/get`)
        .then((response) => {
          if (response.data.status) {
            this.companyId = response.data.data;
          } else {
            this.errorMessage = response.data.message ?? "";
          }
        }).catch(function (error) {
          console.log(error);
        });
    },

    editClicked(record) {
      this.$refs.editEmployee.updateValues(record);
    },

    sickLeaveClicked(record) {
      this.$refs.sickLeave.updateValues(record);
    },

    leavesClicked(record) {
      const routeData = this.$router.resolve({ path: '/employee/leaves-employee', query: { id: record.id } });
      window.open(routeData.href, '_blank');
    },

    attendanceClicked(record) {
      const routeData = this.$router.resolve({ path: '/employee/attendance-employee', query: { id: record.id } });
      window.open(routeData.href, '_blank');
    },
    addFaceTemplateClicked(record) {
      this.$refs.addface.updateValues(record);
    },
    faceTemplatesClicked(employee) {
      this.$refs.faceTemplates.showTemplates(employee);
    },



    openImagePreview(record) {
      if (record.profile_image_path) {
        this.selectedImageUrl = this.getImage(record.profile_image_path);
      } else {
        this.selectedImageUrl = require('../../../assets/img/avatar/avatar-29.png');
      }
      this.selectedEmployeeName = record.name;
      const modal = new Modal(document.getElementById('image_preview_modal'));
      modal.show();
    },

    viewReport(record) {
      this.$refs.employeeReportModal.updateValues(record.id, this.startDate, this.endDate);
      const modal = new Modal(document.getElementById('employee_report_modal'));
      modal.show();
    },
    resetPasswordClicked(record) {
      this.$refs.resetPasswordModal.updateValues(record);
    },
    assignEmployeeClicked(record) {
      this.$refs.assignEmployeeModal.updateValues(record);
    },
  }
};
</script>

<style scoped>
:where(.css-dev-only-do-not-override-1hsjdkk).ant-pagination .ant-pagination-prev,
:where(.css-dev-only-do-not-override-1hsjdkk).ant-pagination .ant-pagination-next {
  background-color: #ffffff00 !important;
}

.inline-item {
  display: inline-block;
  margin-right: 2px;
}

.table-responsive {
  height: 100vh;
  overflow: visible !important;
}

.responsive-img {
  width: 100%;
  max-width: 100px;
  height: auto;
}

.custom-select select {
  appearance: none;
  width: 50px;
  font-size: 14px;
  padding: 2px 5px;
  background-color: #fff;
  border: 1px solid #caced1;
  border-radius: 0.25rem;
  color: #000;
  cursor: pointer;
}

.avatar {
  cursor: pointer;
}

.avatar:hover {
  opacity: 0.8;
}

.preview-image {
  max-height: 70vh;
  object-fit: contain;
  border-radius: 8px;
}

.close-btn {
  background-color: #A6A8A9;
  height: 20px;
  width: 20px;
  border: 1px solid #A6A8A9;
  font-size: 20px;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
}

.close-btn:hover {
  background-color: #099bf8;
  color: #ffffff;
  border-color: #099bf8;
}

.close-btn:hover span {
  color: #FFF;
}

.close-btn span {
  color: #373B3E;
}
</style>
